class MarqueeProducts extends HTMLElement {
  constructor() {
    super();
    this.chips = this.querySelectorAll('.marquee-products__chip');
    this.tracks = this.querySelectorAll('[data-tab-content]');
    this.viewport = this.querySelector('.marquee-products__viewport');

    this.chips.forEach((chip) => {
      chip.addEventListener('click', () => this.activate(chip.dataset.tab));
      chip.addEventListener('keydown', (e) => this.handleChipKeys(e, chip));
    });
  }

  activate(tabName) {
    this.chips.forEach((chip) => {
      const isActive = chip.dataset.tab === tabName;
      chip.classList.toggle('is-active', isActive);
      chip.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    this.tracks.forEach((track) => {
      const isActive = track.dataset.tabContent === tabName;
      track.hidden = !isActive;
      // Reset the swipe position to the first card when a tab becomes visible.
      if (isActive) track.scrollTo({ left: 0 });
    });
  }

  handleChipKeys(e, chip) {
    const chips = Array.from(this.chips);
    const idx = chips.indexOf(chip);
    let target = null;
    if (e.key === 'ArrowRight') target = chips[(idx + 1) % chips.length];
    else if (e.key === 'ArrowLeft') target = chips[(idx - 1 + chips.length) % chips.length];
    else if (e.key === 'Home') target = chips[0];
    else if (e.key === 'End') target = chips[chips.length - 1];
    if (target) {
      e.preventDefault();
      target.focus();
      this.activate(target.dataset.tab);
    }
  }
}

if (!customElements.get('marquee-products')) {
  customElements.define('marquee-products', MarqueeProducts);
}
